
import { ClanName, Dialog, ErrorLoad, PageTitle, StepCSSTransitionGroup } from "@wg/wows-react-uikit";
import { BATTLE_TYPES } from "constants";
import isEmpty from "lodash/isEmpty";
import isNull from "lodash/isNull";
import isNumber from "lodash/isNumber";
import React, { Fragment, PureComponent } from "react";
import dwhExport from '~/dwhExport';
import { translate } from "react-i18next";
import { ClanEditDialogsContainer, ClanLeaveDialogContainer, RecommendationsClanSettingsDialog } from "../../Containers";
import { getLastRegularSeason } from "helpers/ladder";
import ContainerSupply from "../../Containers/ContainerSupply";
import { isoToFormattedLocalDate } from "../../helpers/datetime";
import { t } from "../../helpers/localization";
import { getSeasonTeams } from "../../helpers/seasons";
import { IClan } from "../../Reducers/ReducerSupply";
import settings from "../../settings";
import { Back, BattleSelector, ClanDescriptionDialog, ClanLeagueSign, ClanTitle, ClanWallet, LadderSeasonsDropdown, LadderTeamsDropdown, OwnClanTitle, Ratings, RulesDialog } from "../UIKit/UIKit";
import styles from "./ViewClanProfile.scss";
import {isIngame} from "~/commonmenu";
import { hasPermission, permissions } from "~/roles";

const inGame = isIngame()

export type ViewClanProfile_Props = {
  clanId: number;
  currentAccount: any;
  currentSeasonType: string;
  currentSeason?: number;
  clan: IClan;
  statistics: {
    totalMembers: number;
    maxMembersCount: number;
    averageBattlesCounts: number;
    averageWinsPercentage: number;
    averageExperiencePerBattle: number;
    averageDamagePerBattle: number;
    winsCount: number;
  };
  selectedBattleType: string;
  hasBase: boolean;
  membersError: string;
  isHiddenStatistics: boolean;
  isMissingStatistics: boolean;
  isFetchingJoinClan: boolean;
  isOwn: boolean;
  routeQuery: any;
  isSidebarOpened: boolean;
  wowsLadder: any;
  supplySelectedBuilding: any;
  isMapZoomed: boolean;
  isClanDescriptionDialogVisible: boolean;
  isRenameInProcess: boolean;
  clanRulesContent: any;
  allBonusesActivated: boolean;
  isClanDescriptionEditDialogVisible: boolean;
  isClanNameEditDialogVisible: boolean;
  isClanRulesDialogVisible: boolean;
  isRecommendationsDialogVisible: boolean,
  isLeaveDialogVisible: boolean;
  lastRegularSeasonData: any;

  onSeasonChange: () => void;
  onBattleTypeChange: (battleType: any) => void;
  onMembersReloadClick: () => void;
  onClanReloadClick: () => void;
  onClanDescriptionClick: (descr: string) => void;
  onAcceptInvite: () => void;
  onSendApplication: (clan: any) => void;
  closeClanDescriptionDialog: () => void;
  onRulesDialogClick: () => void;
  onLeaveClick: () => void;
  onNameEditClick: () => void;
  onRecommendationsClanSettingsClick: () => void;
  onDescriptionEditClick: () => void;
  openClanDescriptionEditDialog: () => void;
  closeClanDescriptionEditDialog: () => void;
  closeClanNameEditDialog: () => void;
  openClanRulesDialog: () => void;
  closeClanRulesDialog: () => void;
  openRecommendationsDialog: () => void,
  closeRecommendationsDialog: () => void,
  openLeaveDialog: () => void;
  closeLeaveDialog: () => void;
};

class ViewClanProfile extends PureComponent<ViewClanProfile_Props, any> {


  _profileRatings: any;

  _profileHead: any;

  renderClanName() {
    if (this.props.clan) {
      return <ClanName clanTag={this.props.clan.tag} clanColor={this.props.clan.color} clanName={this.props.clan.name} withTooltip={true} />;
    } else {
      return null;
    }
  }

  onClanDescriptionClick = () => {
    this.props.onClanDescriptionClick(this.props.clan.rawDescription);
  };

  onBattleTypeChange(battleType) {
    if (this.props.isOwn) {
      let battleTypeForDwh = battleType
      if (battleType === "pve") {
          battleTypeForDwh = "coop"
      }
      dwhExport.send('members.select_battle_type', {
          battle_type: battleTypeForDwh
      })
    }
    this.props.onBattleTypeChange(battleType, this.props.clanId);
  }

  onSeasonChange(season) {
    if (this.props.isOwn) {
      dwhExport.send('members.select_season', {
          season: season
      })
    }
    this.props.onSeasonChange(season, this.props.clanId);
  }

  onTeamNumberChange = selectedTeamNumber => {
    if (this.props.currentAccount.clanId === this.props.clanId) {
      dwhExport.send('members.select_team_number', {
          teamNumber: selectedTeamNumber
      })
    }

    this.props.onTeamNumberChange(selectedTeamNumber, this.props.clanId);
  };

  renderDiasbandedClan() {
    return <div>
      <div className={styles.back}>
        <Back />
      </div>
      <StepCSSTransitionGroup level={1}>
        <PageTitle key="page-title" title={this.renderClanName()} />
      </StepCSSTransitionGroup>

      <StepCSSTransitionGroup level={2}>
        <div className={styles.message}>
          <p className={styles.messageText}>{t('Информация недоступна: клан распущен')}</p>
        </div>
      </StepCSSTransitionGroup>
    </div>;
  }

  renderTeamsMenu() {
    return <div className={styles.seasonMenu}>
    <LadderTeamsDropdown selectedTeamNumber = {this.props.selectedTeamNumber} season={this.props.currentSeason} statistics = {this.props.statistics} onTeamNumberChange = {this.onTeamNumberChange} />
  </div>;
  }

  renderSeasonsMenu() {
    if (isNull(this.props.currentSeason)) return null;

    return <div className={styles.seasonMenu}>
      <LadderSeasonsDropdown selectedSeasonId={this.props.currentSeason} selectedSeasonType={this.props.currentSeasonType} onSeasonChange={this.onSeasonChange.bind(this)} dropdownPosition="top" />
    </div>;
  }

  renderActiveClan = () => {
    const league = this.props.lastRegularSeasonData ? this.props.lastRegularSeasonData.league : 0
    const isIssetSeasonDataLeague = isNumber(league);
    const wowsLadderInfo = this.props.wowsLadder ? this.props.wowsLadder[this.props.clan.id] : null;
    const LastRegularSeason = getLastRegularSeason()
    let seasonTeams = null;
    if (wowsLadderInfo && LastRegularSeason) {
      seasonTeams = !isEmpty(wowsLadderInfo) ? getSeasonTeams(wowsLadderInfo.ratings, LastRegularSeason.id) : null;
    }

    let clanLeagueSign = null;

    if (!this.props.hideLeagueIcon && isIssetSeasonDataLeague) {
      let clanLeagueSignProps = {
        clanDivisionRating: this.props.lastRegularSeasonData.division_rating,
        clanMaxDivisionRating: this.props.lastRegularSeasonData.division_rating_max,
        clanDivision: this.props.lastRegularSeasonData.division,
        clanLeague: this.props.lastRegularSeasonData.league,
        clanStage: this.props.lastRegularSeasonData.stage
      };

      if (this.props.isOwn) {
        clanLeagueSignProps = {
          leadingTeamNumber: this.props.lastRegularSeasonData.team_number,
          teamsRating: seasonTeams,
          clanDivisionRating: this.props.lastRegularSeasonData.division_rating,
          clanMaxDivisionRating: this.props.lastRegularSeasonData.division_rating_max,
          clanDivision: this.props.lastRegularSeasonData.division,
          clanLeague: this.props.lastRegularSeasonData.league,
          clanStage: this.props.lastRegularSeasonData.stage,
          isFullSize: false,
          needAboutButton: false
        };
      }

      clanLeagueSign = <div className={styles.clanLeagueSignWrapper}>
        <ClanLeagueSign {...clanLeagueSignProps} />
      </div>;
    }

    const hasClanDescription = !!(this.props.clan.rawDescription && this.props.clan.rawDescription.trim());

    const clanTitle = this.props.isOwn ? <div className={styles.ownClanTitleWrap}>
      <OwnClanTitle
        needMenu
        key="clan-title"
        clanTag={this.props.clan.tag}
        clanColor={this.props.clan.color}
        clanLevel={this.props.clan.leveling}
        accumulativeClanResource={this.props.clan.accumulativeResource}
        clanName={this.props.clan.name}
        hasClanDescription={hasClanDescription}
        isRenameInProcess={this.props.isRenameInProcess}
        roleName={this.props.currentAccount.roleName}
        allBonusesActivated={this.props.allBonusesActivated}
        clanRulesContent={this.props.clanRulesContent}
        onDescriptionEditClick={this.props.openClanDescriptionEditDialog}
        onRecommendationsClanSettingsClick={this.props.onRecommendationsClanSettingsClick}
        onNameEditClick={this.props.onNameEditClick}
        onLeaveClick={this.props.onLeaveClick}
        onRulesDialogClick={this.props.onRulesDialogClick}
        onClanDescriptionClick={this.onClanDescriptionClick}
      />
    </div> : <div className={styles.clanTitleWrap}>
        <ClanTitle key="clan-title" clan={this.props.clan} hasClanDescription={hasClanDescription} currentAccount={this.props.currentAccount} title={this.renderClanName()} subTitle={t('Клан создан %(date)s', { date: isoToFormattedLocalDate(this.props.clan.createdAt) })} isOwn={this.props.isOwn} clanId={this.props.clanId} isFetchingJoinClan={this.props.isFetchingJoinClan} onClanDescriptionClick={this.onClanDescriptionClick} onAcceptInvite={this.props.onAcceptInvite} onSendApplication={this.props.onSendApplication} />
      </div>;

    let isHeaderFooterHidden = false;

    if (this.props.supplySelectedBuilding || this.props.isMapZoomed) {
      isHeaderFooterHidden = true;
    }

    const battleTypes = [];

    settings.battleTypes.forEach(e => {
      battleTypes.push(e);
    });

    return <div>
      <div className={styles.supply}>
        <ContainerSupply clanId={this.props.clanId} />
      </div>

      <div className={`${styles.profileHead} ${isHeaderFooterHidden ? styles.isHidden : ''}`} ref={c => this._profileHead = c}>
        <StepCSSTransitionGroup level={1}>
          {clanLeagueSign}
          {clanTitle}
        </StepCSSTransitionGroup>
      </div>
      <div className={`${styles.profileRatings} ${(isHeaderFooterHidden || this.props.isSidebarOpened) ? styles.isHidden : ''}`} ref={c => this._profileRatings = c}>
        <StepCSSTransitionGroup level={2}>
          <div className={styles.battleSelectorWrap}>
            <BattleSelector clanId={this.props.clan.id} key="battle-selector" items={battleTypes} selected={this.props.selectedBattleType} onBattleTypeChange={this.onBattleTypeChange.bind(this)} dropdownPosition="top" />
          </div>
          {this.props.selectedBattleType === BATTLE_TYPES.REGULAR_CVC || this.props.selectedBattleType === BATTLE_TYPES.BRAWL_CVC ? this.renderSeasonsMenu() : null}
          {this.props.selectedBattleType === BATTLE_TYPES.REGULAR_CVC || this.props.selectedBattleType === BATTLE_TYPES.BRAWL_CVC ? this.renderTeamsMenu() : null}
          <Ratings key="ratings" clanId={this.props.clan.id} currentSeason={this.props.currentSeason} membersError={!!this.props.membersError || this.props.isMissingStatistics} statistics={this.props.statistics} isHiddenStatistics={this.props.isHiddenStatistics} />
        </StepCSSTransitionGroup>
      </div>
      {this.props.isOwn ? <div className={inGame ? styles.clanWallet : styles.clanWalletOffset}>
        <ClanWallet
          clanResource={this.props.clan.personalResource}
          accumulativeResource={this.props.accumulativeResource}
        />
      </div> : null}
    </div>;
  };

  renderError() {
    return <ErrorLoad key="error-load" message={this.props.clan.error || t('Произошла ошибка. Повторите попытку позже')} onReloadClick={this.props.onClanReloadClick} t={t} />;
  }

  render() {
    if (!this.props.clan) return null;

    if (this.props.clan.error) {
      return <StepCSSTransitionGroup level={1}>
        {this.renderError()}
      </StepCSSTransitionGroup>;
    }

    return <Fragment>
      {this.props.clan.isDisbanded ? this.renderDiasbandedClan() : this.renderActiveClan()}

      <Dialog
        content={<ClanDescriptionDialog
          rawDescription={this.props.clan.rawDescription}
          hideDialog={this.props.closeClanDescriptionDialog}
          onDescriptionEditClick={() => {
            this.props.closeClanDescriptionDialog()
            this.props.openClanDescriptionEditDialog()
          }
          }
          isEditButtonShown={this.props.isOwn && hasPermission(this.props.currentAccount.roleName, permissions.CHANGE_SETTINGS)}
        />}
        size={'worship'}
        isOverlay={false}
        isVisible={this.props.isClanDescriptionDialogVisible}
        hideDialog={this.props.closeClanDescriptionDialog}
        t={t}
      />

      <Dialog
        content={<ClanEditDialogsContainer
          dialogType="clanDescription"
        />}
        size={'worship'}
        isOverlay={false}
        isVisible={this.props.isClanDescriptionEditDialogVisible}
        hideDialog={this.props.closeClanDescriptionEditDialog}
        t={t}
      />

      <Dialog
        content={<ClanEditDialogsContainer
          dialogType="clanName"
        />}
        size={'worship'}
        isOverlay={false}
        isVisible={this.props.isClanNameEditDialogVisible}
        hideDialog={this.props.closeClanNameEditDialog}
        t={t}
      />

      <Dialog
        content={<RulesDialog
          data={this.props.clanRulesContent}
          onCloseClick={this.props.closeClanRulesDialog}
        />}
        size={'worship'}
        isOverlay={false}
        isVisible={this.props.isClanRulesDialogVisible}
        hideDialog={this.props.closeClanRulesDialog}
        t={t}
      />

      <Dialog
        content={<RecommendationsClanSettingsDialog />}
        size={'worship'}
        isOverlay={false}
        isVisible={this.props.isRecommendationsDialogVisible}
        hideDialog={this.props.closeRecommendationsDialog}
        t={t}
      />

      <Dialog
        content={<ClanLeaveDialogContainer
        />}
        size={'small'}
        isOverlay={false}
        isVisible={this.props.isLeaveDialogVisible}
        hideDialog={this.props.closeLeaveDialog}
        t={t}
      />

    </Fragment>;
  }
}

export default translate()(ViewClanProfile);